import React from 'react';
import Image from 'next/image';
import { Trans, t } from '@lingui/macro';
import { setQueryParameters } from 'utils/setQueryParameters';
import { IImage, ILink } from 'utils/types';
import { Link } from 'components/link/Link';
import { ChevronRight } from 'components/assets';

import s from './Retailers.module.scss';

type Props = {
  link?: ILink;
  image?: IImage;
  title?: React.ReactNode;
  label?: React.ReactNode;
};

export const Item = ({ link, image, title, label }: Props) => {
  if (!link || !link.href) {
    return null;
  }

  return (
    <article className={s.item}>
      <Link {...link} className={s.item__link}>
        <div className={s.item__layout}>
          <div className={s.item__content}>
            <h3 className={s.item__title}>{title}</h3>
          </div>
          <div className={s.item__image}>
            <div className={s.item__aspect}>
              {image && image.url && (
                // query parameter removes extraneous transparent area around some product images
                <Image src={image.url} layout="fill" objectFit="contain" sizes="640px" />
              )}
            </div>
          </div>
          <div className={s.item__button}>
            {label || <Trans>More</Trans>} <ChevronRight />
          </div>
        </div>
      </Link>
    </article>
  );
};
